import React, { useState } from "react";
import { TrendingUp, Calendar, Check } from "lucide-react";

function RightSidebar() {
  const [joinedMap, setJoinedMap] = useState({
    bansal: true,
  });

  const toggleJoin = (id) => {
    setJoinedMap((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const featuredCommunities = [
    {
      id: "symbiosis",
      name: "Symbiosis College, Pune",
      members: "1.1K",
      iconBg: "bg-rose-500",
    },
    {
      id: "chandigarh",
      name: "Chandigarh University",
      members: "3.8K",
      iconBg: "bg-indigo-600",
    },
    {
      id: "vit",
      name: "VIT Vellore",
      members: "2.6K",
      iconBg: "bg-cyan-600",
    },
  ];

  const trendingTopics = [
    { tag: "# Placements2026", posts: "1.2K posts" },
    { tag: "# Hackathon2025", posts: "856 posts" },
    { tag: "# CollegeLife", posts: "642 posts" },
    { tag: "# StudyMaterial", posts: "512 posts" },
    { tag: "# Internship", posts: "489 posts" },
  ];

  const upcomingEvents = [
    {
      id: "ev1",
      title: "Tech Innovation Summit '26",
      date: "Sep 15",
      time: "10:00 AM",
      location: "Main Auditorium",
    },
    {
      id: "ev2",
      title: "Annual Coding League",
      date: "Sep 22",
      time: "2:00 PM",
      location: "Online / Computer Lab 3",
    },
  ];

  return (
    <aside className="space-y-6">
      {/* Featured Communities Card */}
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100/80 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-gray-900 text-base">
            Featured Communities
          </h3>
          <button className="text-xs font-semibold text-purple-600 hover:text-purple-700 transition-colors">
            View All
          </button>
        </div>

        {/* Featured Spotlight Card */}
        <div className="bg-gradient-to-br from-blue-50/70 via-indigo-50/40 to-purple-50/70 rounded-2xl p-4 border border-blue-100/80 mb-4">
          <div className="flex items-start justify-between">
            <div className="pr-2">
              <h4 className="font-bold text-gray-900 text-sm leading-snug">
                Bansal Institute of Engineering & Tech
              </h4>
              <p className="text-xs text-gray-500 font-medium mt-1">
                1.2K members
              </p>
            </div>
            <div className="w-10 h-10 rounded-xl bg-blue-600 text-white flex items-center justify-center font-bold text-xs shrink-0 shadow-sm">
              BIET
            </div>
          </div>

          {/* Member Avatars */}
          <div className="flex items-center space-x-2 my-3">
            <div className="flex -space-x-2 overflow-hidden">
              <img
                className="inline-block h-6 w-6 rounded-full ring-2 ring-white"
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80"
                alt="Member"
              />
              <img
                className="inline-block h-6 w-6 rounded-full ring-2 ring-white"
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80"
                alt="Member"
              />
              <img
                className="inline-block h-6 w-6 rounded-full ring-2 ring-white"
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80"
                alt="Member"
              />
              <img
                className="inline-block h-6 w-6 rounded-full ring-2 ring-white"
                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80"
                alt="Member"
              />
            </div>
            <span className="text-xs font-semibold text-purple-700 bg-purple-100 px-2 py-0.5 rounded-full">
              +34
            </span>
          </div>

          <button
            onClick={() => toggleJoin("bansal")}
            className={`w-full py-2.5 px-4 rounded-xl font-semibold text-xs transition-all flex items-center justify-center space-x-1 shadow-sm ${
              joinedMap["bansal"]
                ? "bg-purple-600 text-white hover:bg-purple-700"
                : "bg-white text-purple-600 border border-purple-200 hover:bg-purple-50"
            }`}
          >
            {joinedMap["bansal"] ? (
              <>
                <Check size={14} />
                <span>Joined Community</span>
              </>
            ) : (
              <span>Join Community</span>
            )}
          </button>
        </div>

        {/* Recommended List */}
        <div className="space-y-3">
          {featuredCommunities.map((comm) => {
            const isJoined = joinedMap[comm.id];
            return (
              <div
                key={comm.id}
                className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-xl transition-colors"
              >
                <div className="flex items-center space-x-3 min-w-0 pr-2">
                  <div
                    className={`w-8 h-8 rounded-lg ${comm.iconBg} text-white flex items-center justify-center font-bold text-xs shrink-0 shadow-xs`}
                  >
                    {comm.name.charAt(0)}
                  </div>
                  <div className="min-w-0">
                    <h5 className="text-xs font-semibold text-gray-800 truncate">
                      {comm.name}
                    </h5>
                    <p className="text-[11px] text-gray-500 font-medium">
                      {comm.members} members
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => toggleJoin(comm.id)}
                  className={`px-3 py-1 rounded-lg text-xs font-semibold border transition-all shrink-0 ${
                    isJoined
                      ? "bg-purple-50 border-purple-200 text-purple-700"
                      : "bg-white border-gray-200 text-gray-700 hover:border-purple-300 hover:text-purple-600"
                  }`}
                >
                  {isJoined ? "Joined" : "Join"}
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Trending Topics Card */}
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100/80 hover:shadow-md transition-shadow">
        <h3 className="font-bold text-gray-900 text-base mb-4">
          Trending Topics
        </h3>
        <div className="space-y-3">
          {trendingTopics.map((topic, idx) => (
            <div
              key={idx}
              className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-xl transition-colors cursor-pointer group"
            >
              <div>
                <span className="text-sm font-semibold text-gray-800 group-hover:text-purple-600 transition-colors block">
                  {topic.tag}
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {topic.posts}
                </span>
              </div>
              <TrendingUp
                size={16}
                className="text-purple-500 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Upcoming Events Card */}
      <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100/80 hover:shadow-md transition-shadow">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-bold text-gray-900 text-base">
            Upcoming Events
          </h3>
          <button className="text-xs font-semibold text-purple-600 hover:text-purple-700 transition-colors">
            View All
          </button>
        </div>

        <div className="space-y-3">
          {upcomingEvents.map((ev) => (
            <div
              key={ev.id}
              className="p-3 bg-gray-50/80 rounded-xl border border-gray-100 hover:border-purple-100 transition-colors"
            >
              <div className="flex items-start space-x-3">
                <div className="bg-purple-100 text-purple-700 p-2 rounded-lg text-center shrink-0 min-w-[44px]">
                  <Calendar size={14} className="mx-auto mb-0.5" />
                  <span className="text-[10px] font-bold block uppercase leading-none">
                    {ev.date.split(" ")[0]}
                  </span>
                  <span className="text-xs font-extrabold block leading-tight">
                    {ev.date.split(" ")[1]}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <h5 className="text-xs font-bold text-gray-800 truncate">
                    {ev.title}
                  </h5>
                  <p className="text-[11px] text-gray-500 font-medium mt-0.5">
                    {ev.time} • {ev.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}

export default RightSidebar;
